export type CoverageAreaFiltersMessages = {
  servedZipCodeLabel: string;
  startZipCodeLabel: string;
  endZipCodeLabel: string;
  areaDescriptionLabel: string;
  startWeightLabel: string;
  endWeightLabel: string;
  freightChargeOrderLabel: string;
  freightCostCarrierLabel: string;
  regionalDeliveryTimeLabel: string;
  freightTypeLabel: string;
  noFreightTypeCreatedOption: string;
  filterByLabel: string;
  search: string;
  valueLabel: string;
  clearFilterButton: string;
  moreFiltersButton: string;
  lessFiltersButton: string;
  filterButton: string;
  allLabel: string;
};

export const COVERAGE_AREA_FILTERS_MESSAGES: CoverageAreaFiltersMessages = {
  servedZipCodeLabel: "Áreas que atendem o CEP",
  startZipCodeLabel: "CEP Inicial",
  endZipCodeLabel: "CEP Final",
  areaDescriptionLabel: "Descrição da área",
  startWeightLabel: "Peso inicial (Kg)",
  endWeightLabel: "Peso final (Kg)",
  freightChargeOrderLabel: "Frete cobrado",
  freightCostCarrierLabel: "Frete pago",
  regionalDeliveryTimeLabel: "Prazo de Entrega (Dias)",
  freightTypeLabel: "Tipo de frete",
  noFreightTypeCreatedOption: "Nenhum tipo de frete criado",
  filterByLabel: "Filtrar por",
  search: "Pesquisar",
  valueLabel: "Valor",
  clearFilterButton: "Limpar filtros",
  filterButton: "Filtrar",
  allLabel: "Todos",
  moreFiltersButton: "Mais filtros",
  lessFiltersButton: "Menos filtros",
};

export default COVERAGE_AREA_FILTERS_MESSAGES;
